export default __webpack_public_path__ + "assets/images/4d8a9765b8953c760e92a5f3ce8b6895.svg";